import { HIDDEN_ROOTS } from '../config/constants';

export const filterAndFormatDuplicateHits = (hits, getHierarchy) => {
    const hitTypesByName = new Map();
    const affinityLinkIds = new Map();

    hits.forEach((hit) => {
        const { name, type, affinityLinks } = hit;

        affinityLinks.forEach((id) => {
            if (affinityLinkIds.has(id)) {
                affinityLinkIds.set(id, affinityLinkIds.get(id) + 1);
            } else {
                affinityLinkIds.set(id, 1);
            }
        });

        const hitsByName = hitTypesByName.has(type)
            ? hitTypesByName.get(type)
            : hitTypesByName.set(type, new Map()).get(type);

        return hitsByName.has(name)
            ? hitsByName.get(name).push(hit)
            : hitsByName.set(name, [hit]);
    });

    hitTypesByName.forEach((hitsByName, type) => {
        const filteredResults = new Map();
        hitsByName.forEach((nameGroup) => {
            if (nameGroup.length < 2 && nameGroup[0])
                return filteredResults.set(nameGroup[0].id, nameGroup[0]);
            let nameGroupLen = nameGroup.length;
            Array.from(nameGroup)
                .reverse()
                .forEach((hit) => {
                    const { cat1s, hierarchies, depth, id, affinityLinks } =
                        hit;
                    if (
                        depth === 'cat1' &&
                        nameGroup.some(({ parents }) => parents.includes(id))
                    ) {
                        return nameGroupLen--;
                    }
                    const parsedHierarchies = hierarchies
                        ? JSON.parse(hierarchies)
                        : null;
                    // TODO: figure out if this is still needed, if so then refactor and uncomment
                    // If multiple hits have the same affinity link, remove any from within hidden cat1s
                    if (
                        cat1s &&
                        (affinityLinks || []).some(
                            (id) => affinityLinkIds.get(id) > 1,
                        ) &&
                        cat1s.some((cat1) => HIDDEN_ROOTS.includes(cat1))
                    ) {
                        const affinityLinkId = (affinityLinks || []).find(
                            (id) => affinityLinkIds.get(id) > 1,
                        );
                        // Decrement the count so that one result will always be shown
                        affinityLinkIds.set(
                            affinityLinkId,
                            affinityLinkIds.get(affinityLinkId) - 1,
                        );
                        return nameGroupLen--;
                    }
                    const { hierarchy_hint } = getHierarchy(parsedHierarchies);
                    const parentName =
                        hierarchy_hint &&
                        Object.values(hierarchy_hint).length > 1
                            ? Object.values(hierarchy_hint).slice(-2, -1).pop()
                            : null;

                    filteredResults.set(
                        id,
                        nameGroupLen > 1 &&
                            parentName &&
                            parentName !== hit.name
                            ? { ...hit, parentName }
                            : hit,
                    );
                });
        });
        hitTypesByName.set(type, filteredResults);
    });

    if (hitTypesByName.has('product')) {
        const products = hitTypesByName.get('product');
        if (!hitTypesByName.has('brand'))
            hitTypesByName.set('brand', new Map());
        const brands = hitTypesByName.get('brand');
        Array.from(products.values()).forEach(
            ({ brandId, brandName, ...product }) => {
                if (!brands.has(brandId))
                    brands.set(brandId, {
                        name: brandName,
                        id: brandId,
                        type: 'brand',
                        objectID: brandId,
                    });
                const brand = { ...brands.get(brandId) };
                if (!brand.products) brand.products = [];
                brand.products.push(product);
                brands.set(brandId, brand);
            },
        );
        hitTypesByName.delete('product');
    }

    hitTypesByName.forEach((hitsByName, type) =>
        hitTypesByName.set(type, Array.from(hitsByName.values())),
    );

    return Array.from(hitTypesByName.entries());
};

export const createHashtagHits = (hitsWithType) => {
    const hashtags = hitsWithType.reduce((acc, hit) => {
        const hashtagArray =
            hit._highlightResult?.hashtags?.reduce((acc, curr, index) => {
                if (curr.matchLevel === 'full') {
                    acc.push({
                        name: hit.hashtags[index],
                        [`${hit.type}Id`]: hit.id,
                        [`${hit.type}Name`]: hit.name,
                        type: 'hashtag',
                    });
                }
                return acc;
            }, []) || [];
        acc = acc.concat(hashtagArray);
        return acc;
    }, []);

    if (hashtags.length > 0) {
        return ['hashtag', hashtags];
    }

    return [];
};
